import Amplify from 'aws-amplify'
import { AWS_AUTH_CONFIG } from 'config/constants'

const configureAmplify = () => {
    Amplify.configure({ Auth: AWS_AUTH_CONFIG })
}

export default configureAmplify
